<template>
  <div>
    <div class="row p-2 d-flex justify-content-between align-items-center bg-white border-bottom">
      <h4 class="m-0 mr-4 ml-3">PRODUCTS</h4>
      <input
        type="search"
        v-model="filter"
        class="form-control col-6" 
        style="border: none; border-bottom: 1px dashed #cfcfcf;"
        placeholder="Type here to filter by SKU, UPC or name"
      />
      <button class="btn btn-sm btn-dark"> 
        New
      </button>
    </div>    
  
    <div id="products" class="row bg-light">
      <div class="container-fluid mt-3">
        <div class="w-100 p-4" v-if="loading">
          <ContentLoader>
            <rect x="0" y="0" width="400" height="10" />
            <rect x="0" y="20" width="400" height="10" />
            <rect x="0" y="40" width="400" height="10" />
            <rect x="0" y="60" width="400" height="10" />
            <rect x="0" y="80" width="400" height="10" />
            <rect x="0" y="100" width="400" height="10" />
          </ContentLoader>
        </div>    
        <div class="card" v-if="!loading">
          <div>
            <table class="table table-striped w-100">
              <thead class="thead-light">
                <tr>
                  <th>LM SKU</th>
                  <th>Client SKU</th>
                  <th>UPC</th>
                  <th>Name</th>
                  <th>Available</th>
                  <th>On Hand</th>
                  <th>Allocated</th>
                  <th>Inbound</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="prod in products" :key="prod.id">
                  <td nowrap>
                    <router-link :to="`/products/${prod.id}`">LM-{{ prod.id }}</router-link>
                  </td>
                  <td nowrap>{{ prod.customer_sku }}</td>
                  <td>{{ prod.upc }}</td>
                  <td>{{ prod.name }}</td>
                  <td>{{ prod.available }}</td>
                  <td>{{ prod.on_hand }}</td>
                  <td>{{ prod.allocated }}</td>
                  <td>{{ prod.inbound }}</td>
                  <td>
                    <button class="btn btn-sm btn-outline-dark" @click="printLabel(prod.id)">
                      <i class="fa fa-barcode"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import find from 'lodash/find'

import store from '@/stores/products'
import product from '@/libs/product'

import printJS from 'print-js'
import api from '@/api'
import { ContentLoader } from 'vue-content-loader'

export default {
  name: 'products',
  components: {
    ContentLoader
  },

  data() {
    return {
      filter: '',
      loading: true,
    }
  },

  created() {
    product.all().then(res => {
      store.setProducts(res.data.products)
      this.loading = false
    })
  },

  computed: {
    product() {
      return find(store.state.products, { id: parseInt(this.$route.params.id) }) || {}
    },

    products() {

      if (this.filter.length < 1) {
        return store.state.products  
      }
      const filter = this.filter.toUpperCase()
      return store.state.products.filter(p => {
        return p.customer_sku.toUpperCase().startsWith(filter)
          || (p.upc || '').toUpperCase().startsWith(filter)
          || (p.name || '').toUpperCase().includes(filter)
      })
    }
  },

  methods: {
    printLabel(id) {
      printJS({
        printable: api.baseUrl + '/products/' + id + '/label',
        type: 'pdf',
        showModal: true,
        modalMessage: 'Making Label...'
      })      
    }
  }
}
</script>

<style scoped>
#products {
  height: calc(100vh - 48px);
  overflow-y: auto;
  align-content: flex-start
  /* display: flex;
  flex-direction: column; */
}
</style>